module.exports = "<div class=\"q-pill {%- pillClassQty %} q-pill-table\">{%- value %}</div>";


//////////////////
// WEBPACK FOOTER
// ./src/utilities/productsModalUtilities/html/modalPillUnits.html
// module id = 1458
// module chunks = 1